export const checkFeatureFlagEnabled = (featureName: string) =>
  parseInt(process.env[`REACT_APP_${featureName}`] ?? "0") > 0;
